import * as React from 'react';
import AwareComponent from "./AwareComponent";
import { DocumentUnitTypes } from '@af-create/Document/_stores/DocumentStore';
import { DOCUMENT_DATA_DPI, PIXEL_TO_CM } from '@af-create/_config/Consts';
import { connect } from 'react-redux';
import Store from '@af-create/Store';
import { TextField } from '@mui/material';

const mapStateToProps = (store:Store, props:Props) => ({
	units: store.getIn(['create', 'document', 'units'])
});

export type Props = {
	label?: React.ReactNode;
	onChange?: Function;
	onWheel?: Function;
	type?: string;
	value?: string;
	step?: number;
	min?: number;
	max?: number;
	className?: string;
	useUnits?: boolean;
	units?: string;
	variant?: "standard"|"outlined"|"filled"
} & {dispatch?:any}

type State = {
	value: string
}

class TextInput extends AwareComponent<Props, State> {
	constructor(props:Props){
		super(props);
		this.state = { value: "" };
		if(props.value) this.state.value = String(this.toUnits(props.value));
	}

	public componentDidUpdate(prevProps:Props) {
		if(!this.propChanged(prevProps, "value", "useUnits", "units")) return;
		let value = this.toUnits(this.props.value);
		this.setState({value: value});
	}

	private toUnits = (value:string) => {
		if(this.props.useUnits && this.props.units) {
			if(this.props.units == DocumentUnitTypes.Inches) {
				value = String(Number(value) / DOCUMENT_DATA_DPI);
			} else if (this.props.units == DocumentUnitTypes.Centimeters) {
				value = String(Number(value) / PIXEL_TO_CM)
			}
		}
		return value;
	}

	private preventWheel(e:WheelEvent) {
		if(e.target == document.activeElement)
			e.stopPropagation();
	}

	private onChange = (e:React.ChangeEvent<HTMLInputElement>) => {
		let value = e.target.value;
		
		let pixelValue = value;
		if(this.props.useUnits && this.props.units) {
			if(this.props.units == DocumentUnitTypes.Inches) {
				pixelValue = String(Number(value) * DOCUMENT_DATA_DPI);
			} else if (this.props.units == DocumentUnitTypes.Centimeters) {
				pixelValue = String(Number(value) * PIXEL_TO_CM);
			}
		}

		this.setState({value: value});

		if(!this.validate(pixelValue)) return;

		this.props.onChange(pixelValue);
	}

	private validate = (value:string):boolean => {
		let valid = true;
		if(this.props.type == 'number'){
			if(this.props.max && Number(value) > this.props.max) valid = false;
			if(this.props.min && Number(value) < this.props.min) valid = false;
		}
		return valid;
	}

	private stopPropagation = (e:React.MouseEvent) => e.stopPropagation();

	private getStep = () => {
		let step = this.props.step || 1;
		if(this.props.useUnits){
			if(this.props.units == DocumentUnitTypes.Inches) step = 1/8;
			if(this.props.units == DocumentUnitTypes.Centimeters) step = 0.5;
		}
		return step;
	}

	private roundValue = (value:string) => {
		if(this.props.type == 'number' && this.props.useUnits){
			if(this.props.units == DocumentUnitTypes.Inches)
				return Math.round(Number(value) * 10000) / 10000;
			else if (this.props.units == DocumentUnitTypes.Centimeters)
				return Math.round(Number(value) * 10) / 10;
			else return String(Math.round(Number(value)));
		} else return value;
	}

	render() {
		let {onChange, value, useUnits, units, step, min, max, onWheel, dispatch, ...props} = this.props;
		if(min) min = Number(this.roundValue(this.toUnits(String(min))));
		if(max) max = Number(this.roundValue(this.toUnits(String(max))));
		return <TextField
			className={this.props.className}
			variant={this.props.variant as any || "filled"}
			label={props.label || ""}
			onMouseDown={this.stopPropagation}
			onChange={(e:React.ChangeEvent<HTMLInputElement>) => this.onChange(e)}
			value={this.roundValue(this.state.value)}
			{...(props.type == 'number' ? {onWheel: this.preventWheel.bind(this)} : {})} 
			inputProps={{
				step: this.getStep(),
				...(props.type == "number" && {min: min}),
				...(props.type == "number" && {max: max}),
				...props
			}}
		/>
	}
}

export default connect(
	mapStateToProps
)(TextInput);